import http from "./httpService";

export const GetPackage = (data, header) => {
  return http.post("getSupplierPackageData", data, header);
};
